export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  
  newState.settings.errorMessages = {...storeState.settings.errorMessages, ...payload};

  return newState;
};
